import { CommitmentsPeriodsService_lifePeriodsVersionServiceGetDisabilityPeriods } from '@festina/life-general-types/life/hooks/CommitmentsPeriodsService_lifePeriodsVersionServiceGetDisabilityPeriods'

export const useFetchDisabilityPeriods =
  CommitmentsPeriodsService_lifePeriodsVersionServiceGetDisabilityPeriods.useQuery
